export default {
  zh: {//China No.1
    userPlod:'用户名',
    passwordPlod:'密码',
    errorTexl:'',
    LoginIn:'',
  },
  en: {
    userPlod:'userName',
    passwordPlod:'password',
    errorTexl:'username or password error',
    LoginIn:'Login in',
  },
  ar: { // 阿拉伯
    userPlod:'اسم المستخدم',
    passwordPlod:'كلمة المرور',
    errorTexl:'خطا فى الاسم او الرقم السرى المستخدم',
    LoginIn:'الدخول في',
  },
  tr:{ //土耳其
    passwordPlod:'parola',
    userPlod:'kullanıcı adı',
    errorTexl:'Kullanıcı adı veya şifre hatası',
    LoginIn:'Giriş Yap',
  },
  uz: {
        "userPlod": "Foydalanuvchi nomi",
        "passwordPlod": "Parol",
        "errorTexl": "Foydalanuvchi nomi yoki parol xato",
        "LoginIn": "Kirish"
    },
  ru: {
        "userPlod": "Имя пользователя",
        "passwordPlod": "Пароль",
        "errorTexl": "Ошибка имени пользователя или пароля",
        "LoginIn": "Войти"
    },
  fa: {
        "userPlod": "نام کاربری",
        "passwordPlod": "رمز عبور",
        "errorTexl": "نام کاربری یا رمز عبور اشتباه است",
        "LoginIn": "ورود"
    },
    pt: {
        "userPlod": "Nome de usuário",
        "passwordPlod": "Senha",
        "errorTexl": "Erro no nome de usuário ou senha",
        "LoginIn": "Entrar"
    },
    id: {
        "userPlod": "Nama pengguna",
        "passwordPlod": "Kata sandi",
        "errorTexl": "Nama pengguna atau kata sandi salah",
        "LoginIn": "Masuk"
    }
}


// WEBPACK FOOTER //
// src/pages/app/nopaypal/lang.js